module.exports = __WEBPACK_EXTERNAL_MODULE_28__;


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 28
// module chunks = 0